__webpack_require__.p = "https://assets.canny.io/b70f6b445dd509767271a32653fb3d318a30208c/";